import React, { useEffect, useRef } from 'react';
import { inject, observer } from 'mobx-react';
import { getChildInject, getTrans } from '@/utils/instantLoaded/tools';
import { dispatchTrack } from '@/utils/tracking';
import { TRACKING_OPERATION, TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE } from '@/utils/constants';
import { PopUpAnnouncementModalProps } from '@/components/PopUpAnnouncementModal';
import { getScrollElement, throttle } from '@/utils/instantLoaded/toolsWithoutDeps';
import './style.scss';

export interface Announcement {
  id: number;
  title: string;
  message?: string;
  redirection_link?: string;
}

interface Props {
  announcementList: Announcement[];
  popupAnnouncement: PopUpAnnouncementModalProps;
  initStore: any;
  userStore: any;
}

export const trackingName = TRACKING_TYPE.ANNOUNCEMENT;

const Announcements = observer((props: Props) => {
  const announcementsContainerRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <div className="announcements-container" ref={(el) => { announcementsContainerRef.current = el; }} />
    </>
  );
});

export const handleAnnouncementClick = (announcement: Announcement, index: number, sessionId?: number | string, redirectTrackingName?: TRACKING_TYPE.PINNED_ANNOUNCEMENT_REDIRECT) => async () => {
  const { redirection_link } = announcement;
  const currentTrackName = redirectTrackingName ?? trackingName;

  const { redirectionTo } = await import('@/utils/tools');

  redirection_link
    && redirectionTo(redirection_link, null, { navbar: { title: getTrans('announcement') }});

  // 点击上报
  dispatchTrack({
    operation: TRACKING_OPERATION.CLICK,
    section: redirection_link ? TRACKING_SECTION[currentTrackName] : ('' as TRACKING_SECTION),
    target: TRACKING_TARGET[currentTrackName],
    data: {
      chat_session_id: sessionId,
      location: index,
    },
  });
};

export const getPinnedAnnouncementTrackingData = (sessionId: number | string) => {
  return {
    trackingsection: TRACKING_SECTION[TRACKING_TYPE.POP_UP_ANNOUNCEMENT],
    trackingtarget: TRACKING_TARGET[TRACKING_TYPE.POP_UP_ANNOUNCEMENT],
    trackingdataBasic: { chat_session_id: sessionId },
  };
};

export default inject(getChildInject('initStore'))(Announcements);
